import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { pairingSources } from "src/modules/pairing/constants";
import { initiatePairing } from "src/modules/pairing-requester/duck/epics";
import { withPairingRequester } from "src/modules/pairing-requester/PairingRequester/";
import { getPairedDevices } from "src/modules/device/duck/selectors/index";
import { isFreemium } from "src/modules/auth/duck/selectors";
import { withPurchase } from "src/modules/purchase/PurchaseContext";
import NavigationButtons from "src/components/NavigationButtons";
import AlreadyPairedDialog from "../components/AlreadyPairedDialog";
import FailureDialog from "../components/FailureDialog";
import { getPairingCodeInfo } from "../../ajax/cloud";
import View from "./View";

const log = window.require("electron-log");

class EnterCode extends React.Component {
  state = {
    errorMessage: null,
    processing: false,
    alreadyPaired: false,
    codeInfo: null
  };

  handleCodeChange = async (code) => {
    const { shouldOpenPurchaseFlow, purchase } = this.props;
    this.setState({ code });

    if (shouldOpenPurchaseFlow) {
      purchase.open({ content: "unlimited" });
      this.setState({ code: "" });
      return;
    }
    this.setState({ processing: true });

    let codeInfo;
    try {
      codeInfo = await getPairingCodeInfo(code);
      if (codeInfo.isPaired === true) {
        this.setState({ alreadyPaired: true, processing: false, codeInfo });
        return;
      }
    } catch (error) {
      log.error(error);
      this.setState({ errorMessage: error.message });
      return;
    } finally {
      this.setState({ code: "", processing: false });
    }

    const responder = {
      jid: codeInfo.xmppLogin,
      name: codeInfo.deviceName,
      code: codeInfo.code
    };

    const { dispatch, flow, pairingRequester } = this.props;
    const { sendRequestMessage } = pairingRequester;
    dispatch(
      initiatePairing({
        flow,
        sendRequestMessage,
        responder,
        pairingSource: pairingSources.MANUAL_PAIRING
      })
    );
  };

  handleOkClick = () => {
    this.setState({
      alreadyPaired: false,
      errorMessage: null,
      processing: false,
      codeInfo: null
    });
  };

  render() {
    const { code, processing, alreadyPaired, errorMessage, codeInfo } = this.state;
    const { flow, closeWizard, mode, ...rest } = this.props;
    const fill = mode === "fullScreen" ? "mediumEmphasis" : "white";
    return (
      <React.Fragment>
        <FailureDialog
          isOpen={typeof errorMessage === "string"}
          errorMessage={errorMessage}
          onOkClick={this.handleOkClick}
        />
        {alreadyPaired === true && (
          <AlreadyPairedDialog onOkClick={this.handleOkClick} deviceName={codeInfo.deviceName} />
        )}
        <NavigationButtons
          mode={mode}
          backButtonProps={{
            fill: fill,
            onClick: () => flow.push("manual-pairing", { direction: "previous" }),
            disabled: processing
          }}
          closeButtonProps={{
            onClick: closeWizard,
            disabled: processing,
            fill: fill
          }}
        />
        <View onChange={this.handleCodeChange} code={code} flow={flow} mode={mode} processing={processing} {...rest} />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    shouldOpenPurchaseFlow: isFreemium(state) && Object.keys(getPairedDevices(state)).length >= 1
  };
}

const enhance = compose(withPairingRequester, withPurchase, connect(mapStateToProps));

export default enhance(EnterCode);
